import React, { useContext, useState } from "react";
import Typography from "@visa/vds/typography";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import { PageHelper } from "../../../_helpers/PageHelper";
import { TableHelper } from "../../../_helpers/TableHelper";
import { adminService } from "../../../services/admin.service";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import ManageOrganizationsTable from "./ManageOrganizationsTable";
import { AuthContext } from "../../../context/AuthContext";
import { FileHelper } from "_helpers/FileHelper";
import MCSLoading from "components/MCSLoading";

function ManageOrganizations() {
  const PAGE_SIZE = 10;
  let colHeaders = [
    {
      displayName: "Organization",
      name: "organizationName",
      orderable: true,
      defaultOrdered: true,
    },
    { displayName: "BID", name: "bid", orderable: true },
    { displayName: "Region", name: "region.regionName", orderable: true },
    {
      displayName: "VOL Country",
      name: "country.countryName",
      orderable: true,
    },
    {
      displayName: "Licensed Country",
      name: "organizationLicensedBusiness.licensedCountry",
      orderable: true,
    },
    { displayName: "Last Updated By", name: "lastUpdatedBy", orderable: true },
    { displayName: "Last Updated On", name: "lastUpdatedOn", orderable: true },
    { displayName: "# Active Users", name: "usersCount", orderable: true },
    { displayName: "", name: "actions", orderable: false },
  ];

  const [loading, setLoading] = useState(false);
  const [orgFetched, setOrgFetched] = useState(false);
  const [organizationsData, setOrganizationDatas] = useState(null);
  const [ordered, setOrdered] = useState("");
  const [orgTotalPages, setOrgTotalPages] = useState(0);
  const currentUserData = useContext(AuthContext);
  const [searchVal, setSearchVal] = useState("");

  const handleOrganizationPageChange = async (page, search, orderBy, desc) => {
    setOrgFetched(false);
    let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page);
    const res = await adminService.GetOrganizations(
      currentUserData.user.entitleId,
      skipCount,
      search,
      orderBy,
      desc
    );
    const Organization = res.result;
    setOrganizationDatas(Organization);
    setOrgTotalPages(
      PageHelper.GetTotalCountToPages(PAGE_SIZE, Organization.totalCount)
    );
    setOrgFetched(true);
  };

  const handleExportOrganizations = async (alertObj) => {
    setLoading(true)
    adminService.ExportAllOrganizations()
      .then((response) => FileHelper.DownloadFile(response))
      .catch(() => alertObj.setErrorMessage('Error Exporting All Organizations'))
      .finally(() => setLoading(false))
  };

  React.useEffect(() => {
    var defaultSortedCol = TableHelper.GetDefaultOrderedColumn(colHeaders);
    if (defaultSortedCol != null) {
      setOrdered(defaultSortedCol.name);
      handleOrganizationPageChange(1, "", defaultSortedCol.name, false);
    } else {
      handleOrganizationPageChange(1);
    }
  }, []);

  return (
    <GlobalAlertContext.Consumer>
      {(alertObj) => (
        <AuthContext.Consumer>
          {(currentUser) => (
            <>
              <Grid>
                <Row>
                  <Col>
                    <Typography tag="h1">Manage Organizations</Typography>
                  </Col>
                </Row>
                <Row>
                  {loading ? (
                    <MCSLoading />
                  ) : (
                    <ManageOrganizationsTable
                      colHeaders={colHeaders}
                      fetch={handleOrganizationPageChange}
                      ordered={ordered}
                      setOrdered={setOrdered}
                      handleExportOrganizations={() => handleExportOrganizations(alertObj)}
                      searchVal={searchVal}
                      setSearchVal={setSearchVal}
                      PAGE_SIZE={10}
                      fetched={orgFetched}
                      data={organizationsData}
                      totalPages={orgTotalPages}
                    />
                  )}
                </Row>
              </Grid>
            </>
          )}
        </AuthContext.Consumer>
      )}
    </GlobalAlertContext.Consumer>
  );
}

export default ManageOrganizations;
